import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'letter_recommendations';

const LETTER_RECOMMENDATION_ENDPOINTS = {
  listLetterRecommendations: () => formatEndpoint('', namespace),
  markLetterAsViewed: (id: string) => formatEndpoint(`${id}/viewed`, namespace),
  retrieveLetterRecommendation: (id: string) => formatEndpoint(`${id}`, namespace),
};

export default LETTER_RECOMMENDATION_ENDPOINTS;
